import React from "react"
import { navigate } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Container from '@material-ui/core/Container';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Slide from '@material-ui/core/Slide';
import Amplify from 'aws-amplify';

function HideOnScroll(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({ target: window ? window() : undefined });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

HideOnScroll.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  toolbar: {
    minHeight: 128,
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
  },
  logo: {
    [theme.breakpoints.down('sm')]: {
      width: 100,
      height: 100,
    },
    [theme.breakpoints.up('md')]: {
      width: 150,
      height: 150,
    },
  },
  logoButton: {
    marginRight: theme.spacing(4),
  },
  spacer: {
    flexGrow: 1,
  },
  list: {
    width: 300,
  },
  menuWapper: {
  },
  toolbarDummy: {
    minHeight: 174,
    [theme.breakpoints.down('sm')]: {
      minHeight: 126,
    },
  }
}));

const HeaderBar = ( props ) => {
  const user = props.user;
  const pointName = props.pointName;

  const data = useStaticQuery(graphql`
    query HeaderBarQuery {
      logo: file(absolutePath: { regex: "/logo.png/" }) {
        childImageSharp {
          fluid(maxWidth: 120) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  const logo = data?.logo?.childImageSharp?.fluid
  const classes = useStyles();

  const signout = async () => {
    try {
      await Amplify.Auth.signOut();
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

  return (
    <React.Fragment>
      <HideOnScroll {...props}>
        <AppBar position="fixed" color="inherit" elevation={0}>
          <Container>
            <Toolbar className={classes.toolbar}>
              {pointName ? (
                <Typography variant="h5" component="p">
                  {pointName}
                </Typography>
              ) : (
                <IconButton onClick={e => navigate('/')} edge="start" className={classes.logoButton} color="inherit" aria-label="logo">
                  {logo && (
                      <Image
                        fluid={logo}
                        alt={logo?.name || `Islands Watch`}
                        className={classes.logo}
                        imgStyle={{
                        }}
                      />
                  )}
                </IconButton>
              )}
              <div className={classes.spacer} />
              {user !== false &&
                <Button variant="outlined" color="primary" onClick={signout}>
                  <PermIdentityIcon />サインアウト
                </Button>
              }

            </Toolbar>
          </Container>
        </AppBar>
      </HideOnScroll>
      <Toolbar className={classes.toolbarDummy} />
    </React.Fragment>
  );
}

export default HeaderBar
